import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useParams } from 'react-router-dom';

import {
  ROUTE_PREFIX_PRE_APPT,
  ROUTE_PREFIX_WORKFLOW_ID,
  ROUTES_PRE_APPT,
} from '../../constants/routes';
import PreApptRouteWrapper from '../../components/PreApptPayment/PreApptRouteWrapper';
import PageLoader from '../../components/common/PageLoader';
import PaymentConfirmation from './PaymentConfirmation';
import Reschedule from './Reschedule';
import PreApptWrapper from './PreApptWrapper';
import DOBVerification from './DOBVerification';
import PaymentLinkStatusView from './NoApptOrPaymentInfoPage/PaymentLinkStatusView';
import { PAYMENT_LINK_STATE } from './NoApptOrPaymentInfoPage/paymentLinkStates';
import { STATUS } from '../../constants';
import {
  fetchVerifiedWorkflowById,
  isWorkflowVerified,
  setVerifiedWorkflow,
} from '../../slices/workflow';
import { getPatientAccessToken } from '../../utils/patientAccessStorage';

const PreApptPayment = () => {
  const dispatch = useDispatch();
  const { workflowId } = useParams();
  const workflowState = useSelector(({ workflow }) => workflow);
  const { data: workflow, status: workflowFetchingStatus } = workflowState;
  const isVerified = isWorkflowVerified(workflowState, workflowId);
  const [isLinkNotRecognised, setIsLinkNotRecognised] = useState(false);
  const hasAccessToken = Boolean(getPatientAccessToken(workflowId));

  useEffect(() => {
    if (!isVerified && hasAccessToken) {
      dispatch(fetchVerifiedWorkflowById(workflowId));
    }
  }, [dispatch, workflowId, isVerified, hasAccessToken]);

  if (!isVerified) {
    if (isLinkNotRecognised) {
      return (
        <PaymentLinkStatusView linkState={PAYMENT_LINK_STATE.NOT_RECOGNISED} />
      );
    }

    if (hasAccessToken && workflowFetchingStatus !== STATUS.FAILURE) {
      return <PageLoader />;
    }

    return (
      <DOBVerification
        workflowId={workflowId}
        onVerified={(verifiedWorkflow) =>
          dispatch(
            setVerifiedWorkflow({ workflowId, workflow: verifiedWorkflow })
          )
        }
        onNotFound={() => setIsLinkNotRecognised(true)}
      />
    );
  }

  return (
    <Switch>
      <PreApptRouteWrapper
        path={
          ROUTE_PREFIX_PRE_APPT +
          ROUTE_PREFIX_WORKFLOW_ID +
          ROUTES_PRE_APPT.PAYMENT_CONFIRMATION
        }
      >
        <PaymentConfirmation />
      </PreApptRouteWrapper>

      {/* Not in PreApptRouteWrapper: a paid appointment can be rescheduled too. */}
      <Route
        path={
          ROUTE_PREFIX_PRE_APPT +
          ROUTE_PREFIX_WORKFLOW_ID +
          ROUTES_PRE_APPT.RESCHEDULE
        }
      >
        <Reschedule />
      </Route>

      <Route path={ROUTE_PREFIX_PRE_APPT + ROUTE_PREFIX_WORKFLOW_ID}>
        <PreApptWrapper workflow={workflow} />
      </Route>
    </Switch>
  );
};

export default PreApptPayment;
